export default {
  getSynonymSearchResult: (state) => state.synonymSearchResult,
};
